'use strict';

var globalThis = require('../internals/global-this');
var isCallable = require('../internals/is-callable');
var WeakMap = globalThis.WeakMap;
module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));